import { FieldBtn } from '../../../dues/dues.style'
import { gql, useMutation} from '@apollo/client';
import Cookies from 'js-cookie';
import React, { useState } from 'react'
import {toaster,Spinner} from 'evergreen-ui';

export const ADD_SUBADMIN = gql`
mutation SubAdmin_assign($managerName: String!, $managerEmail: String!, $managerPhone: String!, $facilityId: ID!, $fullAccess: Boolean!, $permissions: [SubAdminPermissionInput!]!) {
  subAdmin_assign(managerName: $managerName, managerEmail: $managerEmail, managerPhone: $managerPhone, facilityId: $facilityId, fullAccess: $fullAccess, permissions: $permissions) {
    code
    error
    success
    data {
      _id
      fullAccess
      inviteStatus
      isActive
      unassignedDate
      unassignedReason
      assignedDate
      permissions {
        fullAccess
        mutationAccess
        queryAccess
        resource
      }
    }
  }
}
`;


function ResendAdminInvite(props) {
  const accesTokenValue = Cookies.get('userAccessToken');
  const subAdmin =props.data;
  const [addSubAdmin, { loading }] = useMutation(ADD_SUBADMIN);
  const [dataObject] = useState({
    managerName: subAdmin.facilityManager.name,
    managerEmail:subAdmin.facilityManager.email,
    managerPhone:subAdmin.facilityManager.phone,
    facilityId:subAdmin.facility._id,
    fullAccess:subAdmin.fullAccess,
    permissions:subAdmin.permissions
  });
  const handleSubmit=(e)=>{
      e.preventDefault()
    
      console.log(dataObject)
      
      addSubAdmin({
        variables:dataObject,
        context: {
          headers: {
            Authorization: `Bearer ${accesTokenValue}`,
          },
        },
      })
      .then((response) => {
        toaster.success("Sub-admin invite sent successfully.")
        setTimeout(()=>{
            window.location.reload()
        },2000)
      })
      .catch((error) => {
        toaster.danger(error.message)
      });
    }
  return (
    <div>
        {loading
          ?<Spinner/>
          : <FieldBtn 
            onClick={handleSubmit}
            loading={loading}
          class="waves-effect waves-light btn-flat ">
                  Resend Invite 
          </FieldBtn>
        }
       
    </div>
  )
}

export default ResendAdminInvite